import { createReducer, on} from "@ngrx/store"
import { IGetPolicyListResponse } from "./policy.models"
import { savePolicyList, setPolicy } from "./policy.actions";


export const initialState: IGetPolicyListResponse = null;

export const policyReducers = createReducer(
    initialState,
    on(savePolicyList, (state, { list }) => {return { ...state, list} }),
    on(setPolicy, (state, { policyItem }) => {return { ...state, policyItem: policyItem} })
);